import { httpsCallable } from 'firebase/functions';
import { functions } from '../config/firebase';

export const callGemini = async (promptText, isJsonMode = true, base64Image = null) => {
  const askGemini = httpsCallable(functions, 'askGemini');
  
  try {
    const result = await askGemini({ 
      promptText, 
      base64Image, 
      isJsonMode 
    });
    
    // Il server ci restituisce già il JSON pulito o il testo semplice!
    return isJsonMode ? result.data : result.data.text;
    
  } catch (error) {
    console.error("Errore Cloud Function Gemini:", error);
    throw error;
  }
};